import { Component, OnInit } from '@angular/core';
import { CstemapiService } from '../cstemapi.service';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-appinfo',
  templateUrl: './appinfo.component.html',
  styleUrls: ['./appinfo.component.scss']
})
export class AppinfoComponent implements OnInit {
  chooseOptions: any;

  constructor(public cstemapi: CstemapiService, private auth: AuthService, private myRoute: Router) { 
    this.chooseOptions = this.auth.getOptions();
    // console.log(this.chooseOptions)
  }

  ngOnInit() {
  }

}
